import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles(() => ({
    sourceContainer: {
      textAlign: "center",
      marginTop: "0.5em",
    },
}));

const LinkedImage = (props) => {
    const { link, alt, link2=null, alt2=null, availSize=null } = props;
    const classes = useStyles();
    const [ imgDimensions, setImgDimensions ] = useState({});
    const [ newWidth, setNewWidth ] = useState("100%");

    const resizeWidth = () => {
        const pctWidth = availSize.width / imgDimensions.width;
        const pctHeight = availSize.height / imgDimensions.height; 
        const usePct = Math.min(pctHeight, pctWidth);
        setNewWidth(imgDimensions.width * usePct);
    };

    const handleOnload = (event) => {
        if (availSize) {
            // resize to fit in window vertically and horizontally
            const imgWidth = event.target.clientWidth;
            const imgHeight = event.target.clientHeight;
            const imgSize = {width:imgWidth, height:imgHeight}
            setImgDimensions(imgSize);
        };
    };

    // update width as window size changes
    useEffect(() => {
        if (availSize) {
            resizeWidth();
        }
    }, [availSize, imgDimensions] );     // eslint-disable-line react-hooks/exhaustive-deps
 
    return (
        <>
            <img 
                src={link} 
                alt={alt} 
                width={newWidth.toString()}
                onLoad={handleOnload}
            />
            <div 
                className={classes.sourceContainer}
                style={{...(newWidth ? {width: newWidth} : {width:"100%"})}}
            >
                {link2 && alt2 &&
                    <img 
                        src={link2}
                        alt={alt2}
                        width={(newWidth*0.5).toString()}
                    />
                }
                <Typography variant="caption" paragraph={true}>
                    Source: {link}
                </Typography>
            </div>
        </>
    )
}

export default LinkedImage;